enum subscriptionConstants {
  SUBSCRIPTIONFORM = '/subscriptions',
  SUBSCRIPTION_COREFEATURES = '/subscription-core-features',
  SUBSCRIPTION_ADDITIONALFEATURES = '/subscription-additional-features',
}
export default subscriptionConstants;
